<div class="history">
  <p class="copec-rg-20" style="line-height: 34px">Historial</p>
  <div class="content-history">
    <table id="historytable">
      <caption></caption>
      <th></th>

      <tr *ngFor="let item of dataHistory">
        <td style="display: inline-block">
          <img src="../assets/icon-summary/check.svg" alt="" />
        </td>
        <td>
          <div>
            <p class="copec-rg-16" style="margin-bottom: 0.5rem">
              <strong>{{textReplace(item.comentario.cabecera_mensaje)}}</strong>
              {{textReplace(item.comentario.detalle_mensaje)}}</p>
            <div style="background-color: #f5f6fa; padding: 0px 0px 0px 5px">
              <!-- Motivo de aprobación -->
              <p class="copec-rg-16 motivo-history"
                *ngIf="item.comentario.cabecera_mensaje && item.comentario.cabecera_mensaje.includes('Aprobado') && motivoAprobacion && motivoAprobacion.trim() !== ''">
                <span class="copec-rg-16">Comentario de aprobación:</span> {{motivoAprobacion}}
              </p>
              <!-- Motivo de rechazo -->
              <p class="copec-rg-16 motivo-history" *ngIf="!isObjectEmpty(item.comentario.motivos_rechazo)">
                <span class="copec-rg-16">Motivo:</span> {{item.comentario.motivos_rechazo}}
              </p>
              <p class="copec-rg-16 motivo-history"
                *ngIf="!isObjectEmpty(item.comentario.atributos_corregir.motivo_correccion)">
                <span class="copec-rg-16">Motivo:</span> {{item.comentario.atributos_corregir.motivo_correccion}}
              </p>
              <p class="copec-rg-16 motivo-history"
                *ngIf="!isObjectEmpty(item.comentario.atributos_corregir.comentario_correccion)">
                <span class="copec-rg-16">Comentario:</span>
                {{item.comentario.atributos_corregir.comentario_correccion}}
              </p>
              <div *ngIf="!isObjectEmpty(item.comentario.atributos_corregir.campos_corregir)">
                <p class="copec-rg-16 motivo-history">Campos que se solicita corregir:</p>
                <div *ngFor="let i of item.comentario.atributos_corregir.campos_corregir"
                  style="background-color: #f5f6fa;">
                  <div class="content-table" *ngFor="let x of i.data">

                    <div style="background-color: #f5f6fa; padding: 0px 0px 14px 0px">
                      <ul class="copec-lg-16" style="margin-bottom: 0;">
                        <li>{{x.key.replaceAll('_', ' ') }}</li>
                        <li *ngIf="i.title === 'Archivos adjuntos'">
                          {{i.title}}
                        </li>
                      </ul>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <p class="copec-lg-12 colorgray" style="line-height: 16px">
            {{ item.fecha | date:'dd/MM/yyyy HH:mm:ss' }}
          </p>
        </td>
      </tr>
    </table>
  </div>
</div>